import React from 'react';
import PropTypes from 'prop-types';
import Space from '@src/components/Space';
import SwipeSlider from '@src/components/SwipeSlider';

const MapSlider = (props) => {
	const { cards, onClickHeart, slideMix } = props;
	return (
		<SwipeSlider
			dotsType="purple"
			slideMix={slideMix}
			adaptive="mapLayer"
			centred
			isWithDots
			centerInsufficientSlides
			swipeQtty="auto"
		>
			{cards.map((card) => {
				return (
					<Space
						key={card.id}
						moreLabel={t('Подробнее')}
						iconLinkState="small"
						adaptive="mapLayer"
						moreTarget="_blank"
						onClickHeart={onClickHeart}
						{...card}
					/>
				);
			})}
		</SwipeSlider>
	);
};

MapSlider.propTypes = {
	cards: PropTypes.arrayOf(PropTypes.shape(Space.type.propTypes)),
	onClickHeart: PropTypes.func,
	slideMix: PropTypes.string,
};

MapSlider.defaultProps = {
	onClickHeart: undefined,
	slideMix: undefined,
	cards: [],
};

export default MapSlider;
